
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1ouZ7", function(module, exports) {

$parcel$export(module.exports, "fireCustomHomepageClickedAnalytics", () => $dd9a8a11ea34b6c5$export$ec83916a1ca3a7c);
$parcel$export(module.exports, "fireHomeClickedAnalytics", () => $dd9a8a11ea34b6c5$export$5fa0d2139c0e0457);
$parcel$export(module.exports, "fireRecentsClickedAnalytics", () => $dd9a8a11ea34b6c5$export$22e0f3cc7763cf21);
$parcel$export(module.exports, "fireSpacesClickedAnalytics", () => $dd9a8a11ea34b6c5$export$4a4f812c5044dd68);
$parcel$export(module.exports, "firePeopleClickedAnalytics", () => $dd9a8a11ea34b6c5$export$fe3de2022316f901);
$parcel$export(module.exports, "fireAppsClickedAnalytics", () => $dd9a8a11ea34b6c5$export$d6cf8dac1ccaf0a0);
$parcel$export(module.exports, "fireTemplatesClickedAnalytics", () => $dd9a8a11ea34b6c5$export$144ccba5c4c7989e);

var $dEBDF = parcelRequire("dEBDF");
const $dd9a8a11ea34b6c5$export$ec83916a1ca3a7c = (createAnalyticsEvent, routeName)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'customHomepage',
                attributes: {
                    selectedItemPageContext: routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    };
const $dd9a8a11ea34b6c5$export$5fa0d2139c0e0457 = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'home',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    };
const $dd9a8a11ea34b6c5$export$22e0f3cc7763cf21 = (createAnalyticsEvent, routeDataRef)=>(isExpanded)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'recents',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH),
                    status: isExpanded ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    };
const $dd9a8a11ea34b6c5$export$4a4f812c5044dd68 = (createAnalyticsEvent, routeDataRef)=>(isExpanded)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'spaces',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH),
                    status: isExpanded ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    };
const $dd9a8a11ea34b6c5$export$fe3de2022316f901 = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'peopleMenuDropdown',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    };
const $dd9a8a11ea34b6c5$export$d6cf8dac1ccaf0a0 = (createAnalyticsEvent, routeDataRef)=>(isExpanded)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'apps',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH),
                    status: isExpanded ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    };
const $dd9a8a11ea34b6c5$export$144ccba5c4c7989e = (createAnalyticsEvent, routeDataRef)=>()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'templates',
                attributes: {
                    selectedItemPageContext: routeDataRef.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.TOUCH)
                }
            }
        }).fire();
    };

});


//# sourceMappingURL=analyticsCallbacks.6e180fc8.js.map
